module.exports = __webpack_public_path__ + "static/media/advantage2.d94d2b82.png";